module.exports = __webpack_public_path__ + "img/icon-firefox.8d650c53.svg";